export default class UserQuestionForm {
  public title: string = ''
  public body: string = ''
  public from?: string
  public tags: string[]
  public questionType: string
  public materials: File[] = []
  public courseId?: string = ''
  public lessonId?: string = ''

  toFormData() {
    const formData = new FormData()

    if (this.materials.length > 0) {
      this.materials.forEach(file => {
        formData.append('materials[]', file)
      })
    }
    if (this.title) {
      formData.append('title', this.title)
    }
    if (this.body) {
      formData.append('body', this.body)
    }
    if (this.questionType) {
      formData.append('question_type', this.questionType)
    }
    if (this.courseId) {
      formData.append('course_id', this.courseId)
    }
    if (this.lessonId) {
      formData.append('lesson_id', this.lessonId)
    }

    return formData
  }
}

export class UserQuestionListForm {
  public page: number = 1
  public relativeableType?: 'Lesson' | 'Course'
  public relativeableId?: number
  public search?: string = ''
}
